import { PresentationInfo, ComparisonNudgeVariant } from "@swiggy-private/cart-types";
import { isEmpty } from "@swiggy-private/js-utils";

export type SubscriptionRenewalWidgetPosition = "before_menu_items" | "before_bill_details" | null;

/**
 * Helper function to determine the positioning of the subscription renewal widget
 * based on the backend variant configuration
 */
export const getSubscriptionRenewalWidgetPositioning = (
    swiggyPlanInfo?: PresentationInfo,
): ComparisonNudgeVariant | null => {
    const comparisonNudgeComms = swiggyPlanInfo?.comparison_nudge_comms;
    // Early return if no comparison nudge comms or empty array
    if (isEmpty(comparisonNudgeComms)) {
        return null;
    }

    const variant = comparisonNudgeComms?.variant;

    if (!variant) {
        return null;
    }

    return variant;
};

/**
 * Helper function to validate subscription renewal widget data
 */
export const isSubscriptionRenewalWidgetDataValid = (swiggyPlanInfo?: PresentationInfo): boolean => {
    const comparisonNudgeComms = swiggyPlanInfo?.comparison_nudge_comms;
    return Boolean(comparisonNudgeComms?.nudges?.length && comparisonNudgeComms?.nudges[0]?.plan_details?.plan_id);
};
